export default __webpack_public_path__ + "static/media/showFilterIcon.ab5e25c1.svg";